import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const MonthlyPlanList = Loadable(lazy(() => import("./MonthlyPlanList")));
const MonthlyPlanForm = Loadable(lazy(() => import("./MonthlyPlanForm")));

const monthlyPlanRoutes = [
  {
    path: "/MonthlyPlan/MonthlyPlanList",
    element: <MonthlyPlanList />,
    permission: PERMISSIONS.MonthlyPlans.Menu,
  },
  {
    path: "/MonthlyPlan/MonthlyPlanForm",
    element: <MonthlyPlanForm />,
  },
  {
    path: "/MonthlyPlan/MonthlyPlanForm/:monthlyPlanId",
    element: <MonthlyPlanForm />,
  },
];

export default monthlyPlanRoutes;
